import {testIdProps} from '@github-ui/test-id-props'
import {Box, CounterLabel, Text} from '@primer/react'

type DisabledFilterInputProps = {
  query: string
  onClickHandler?: () => void
  filterCount?: number
  icon?: React.ReactNode
}

export const DisabledFilterInput = ({query, onClickHandler, filterCount, icon}: DisabledFilterInputProps) => {
  return (
    <Box
      {...testIdProps('disabled-filter-input')}
      onClick={onClickHandler}
      sx={{
        border: theme => `1px solid ${theme.colors.border.default}`,
        borderRadius: 2,
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        maxWidth: '100%',
        pl: 2,
        pr: [3, 4, 5],
        position: 'relative',
        color: theme => `${theme.colors.primer.fg.disabled}`,
        backgroundColor: theme => `${theme.colors.input.disabledBg}`,
        minHeight: '32px',
        cursor: 'text',
      }}
    >
      <Box sx={{alignItems: 'center', maxWidth: '100%', display: 'flex'}}>
        {icon}
        <Text sx={{pl: 2, pr: 2, whiteSpace: 'nowrap'}}>{query}</Text>
        {filterCount !== undefined && (
          <CounterLabel {...testIdProps('disabled-filter-results-count')}>{filterCount}</CounterLabel>
        )}
      </Box>
    </Box>
  )
}

try{ DisabledFilterInput.displayName ||= 'DisabledFilterInput' } catch {}